import styled from "styled-components";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  desktopMarginVal,
  desktopMarginsCutoff,
  mobileMarginVal,
} from "../../styleConstants";

const StickyHeader = styled.div`
  // flex-shrink 0 means this header will not be shrunk even if contents are very big and become scrollable.
  flex-shrink: 0;
  background: white;
  border-bottom: 1px solid #e5e5e5;

  padding-top: 16px;
  padding-bottom: 10px;
  margin-left: ${mobileMarginVal}px;
  margin-right: ${mobileMarginVal}px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    padding-bottom: 14px;
    margin-left: ${desktopMarginVal}px;
    margin-right: ${desktopMarginVal}px;
  }
`;

const X = styled.div`
  font-size: 26px;
  color: black;
`;

const ClickableX = styled.span`
  cursor: pointer;
`;

const SlideInHeader = ({ close }) => (
  <StickyHeader>
    <X>
      <ClickableX>
        <FontAwesomeIcon icon={faXmark} onClick={close} />
      </ClickableX>
    </X>
  </StickyHeader>
);

SlideInHeader.propTypes = {
  close: PropTypes.func,
};

export default SlideInHeader;
